import gsap from 'gsap'
import SmoothScroll from '../utils/SmoothScroll'

export default class Menus {
	constructor() {
		this.menuOpen = false
		this.abortController = new AbortController()
		this.lenis = new SmoothScroll().lenis

		this.header = document.querySelector('header')
		this.menu = document.querySelector('[data-menu]')
		this.menuOverlay = document.querySelector('[data-menu-overlay]')
		this.menuItems = document.querySelectorAll('[data-menu-item]')
		this.menuButtons = document.querySelectorAll('[data-toggle-menu]')
		this.menuHide = document.querySelectorAll('[data-menu-hide]')
		this.menuButtonText = document.querySelectorAll('[data-menu-text]')
		this.menuButtonLines = document.querySelectorAll('[data-menu-lines]')

		if (!this.menu) return

		this.#buildTimeline()
		this.#bindEvents()
	}

	#buildTimeline() {
		const itemInners = gsap.utils.toArray('[data-menu-item] > *')

		gsap.set(this.menuItems, { overflow: 'hidden' })

		this.timeline = gsap
			.timeline({ paused: true })
			.to(this.menuButtonText, {
				yPercent: -100,
				duration: 0.3,
				ease: 'power2.inOut',
			})
			.to(
				this.menuButtonLines[0],
				{
					width: '75%',
					duration: 0.4,
					ease: 'power2.out',
				},
				'<='
			)
			.to(
				this.menuButtonLines[1],
				{
					width: '50%',
					duration: 0.4,
					ease: 'power2.out',
				},
				'<='
			)
			.to(
				this.menuOverlay,
				{
					pointerEvents: 'auto',
					opacity: 1,
					backdropFilter: 'blur(20px)',
					duration: 0.4,
					ease: 'power2.out',
				},
				'<='
			)
			.to(
				this.menuHide,
				{
					opacity: 0,
					duration: 0.4,
					pointerEvents: 'none',
					ease: 'power2.out',
				},
				'<='
			)
			.to(
				this.menu,
				{
					pointerEvents: 'auto',
					height: 'auto',
					duration: 0.5,
					ease: 'power2.inOut',
				},
				'<='
			)
			.from(
				itemInners,
				{
					yPercent: 100,
					duration: 0.5,
					stagger: 0.04,
					ease: 'power3.out',
				},
				'<=20%'
			)
	}

	#bindEvents() {
		const { signal } = this.abortController

		this.menuButtons.forEach(btn => {
			btn.addEventListener('click', () => this.toggle(), { signal })
		})

		document.querySelector('main')?.addEventListener(
			'click',
			() => {
				if (this.menuOpen) this.close()
			},
			{ signal }
		)

		this.menuOverlay.addEventListener(
			'click',
			() => {
				if (this.menuOpen) this.close()
			},
			{ signal }
		)

		document.addEventListener(
			'keydown',
			e => {
				if (e.key === 'Escape' && this.menuOpen) this.close()
			},
			{ signal }
		)
	}

	toggle() {
		this.menuOpen ? this.close() : this.open()
	}

	open() {
		this.menuOpen = true
		document.body.classList.add('menu-open')
		this.header?.classList.add('menu-active')
		this.lenis.stop()
		this.timeline.play()
	}

	close() {
		this.menuOpen = false
		document.body.classList.remove('menu-open')
		this.header?.classList.remove('menu-active')
		this.lenis.start()
		this.timeline.reverse()
	}

	destroy() {
		this.abortController?.abort()
		this.timeline?.kill()
	}
}
